import React, { useState } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Typography, Icons } from '@hmsexp/component-library';
import { isFunction } from 'lodash';

const HeaderSortCell = ({ column, handleSort, componentMap, sortConfig }) => {
  const [isPressed, setPressed] = useState(false);
  const direction = sortConfig.field === column.field ? sortConfig.direction : null;

  const isSortable = column?.sortable === true;

  const toggleSort = () => {
    if (!isSortable) return;

    const newDirection = direction === null ? 'asc' : direction === 'asc' ? 'desc' : null;

    handleSort(column.field, newDirection);
  };

  const justifyContent = isSortable ? 'flex-end' : 'flex-start';

  const borderStyle = isPressed ? styles.borderPressed : direction ? styles.borderActive : styles.borderDefault;

  const textColor = isSortable && direction ? '#2F80ED' : '#1b2438';

  if (isFunction(componentMap?.[column?.field]?.header)) {
    return componentMap[column.field].header({ column, isHeader: true });
  }

  return (
    <TouchableOpacity
      disabled={!isSortable}
      onPress={toggleSort}
      onMouseEnter={() => isSortable && setPressed(true)}
      onMouseLeave={() => isSortable && setPressed(false)}
      style={[styles.touchable, { justifyContent }, borderStyle]}>
      <Typography
        variant='body2'
        fontWeightType='semiBold'
        color={textColor}
        style={[styles.typography, isSortable ? styles.typographyWithRightMargin : null]}>
        {column.label}
      </Typography>

      {isSortable && (
        <View style={styles.iconContainer}>
          <View style={styles.iconScaleWrapper}>
            <Icons.ChevronUp size='XS' stroke={direction === 'asc' ? '#2F80ED' : '#c6d1ec'} />
          </View>
          <View style={styles.iconScaleWrapper}>
            <Icons.ChevronDown size='XS' stroke={direction === 'desc' ? '#2F80ED' : '#c6d1ec'} />
          </View>
        </View>
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  touchable: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    paddingHorizontal: 6,
    paddingVertical: 4,
    gap: 8
  },
  borderDefault: {
    borderBottomWidth: 1,
    borderBottomColor: '#dde1e5'
  },
  borderPressed: {
    borderBottomWidth: 2,
    borderBottomColor: '#9bbbe8'
  },
  borderActive: {
    borderBottomWidth: 2,
    borderBottomColor: '#2f78d0'
  },
  typography: {
    flexShrink: 1
  },
  typographyWithRightMargin: {
    marginRight: 8
  },
  iconContainer: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  iconScaleWrapper: {
    transform: [{ scale: 0.65 }]
  }
});

export default HeaderSortCell;
